import ZeroMd from 'zero-md';

customElements.define('zero-md', ZeroMd);
